var map = {
	"./decidim/avatar-multiuser.png": 85545,
	"./decidim/brands/google.svg": 69380,
	"./decidim/cc-badge.png": 71199,
	"./decidim/decidim-logo.svg": 50427,
	"./decidim/default-avatar.svg": 16927,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 46789,
	"./decidim/icons.svg": 79038,
	"./decidim/pattern.png": 56109,
	"./decidim/placeholder-card-g.svg": 3426,
	"./decidim/placeholder-card-l.svg": 78761,
	"./decidim/placeholder.jpg": 58552,
	"./decidim/remixicon.symbol.svg": 49178,
	"./decidim/vendor/leaflet/layers-2x.png": 81815,
	"./decidim/vendor/leaflet/layers.png": 51230,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 62323,
	"./decidim/vendor/leaflet/marker-icon.png": 56330,
	"./decidim/vendor/leaflet/marker-shadow.png": 45753,
	"./decidim/vendor/social-share-button/douban.svg": 58749,
	"./decidim/vendor/social-share-button/email.svg": 34814,
	"./decidim/vendor/social-share-button/facebook.svg": 35606,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 70746,
	"./decidim/vendor/social-share-button/hacker_news.svg": 49518,
	"./decidim/vendor/social-share-button/linkedin.svg": 90676,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 82445,
	"./decidim/vendor/social-share-button/pinterest.svg": 56296,
	"./decidim/vendor/social-share-button/reddit.svg": 31522,
	"./decidim/vendor/social-share-button/telegram.svg": 7235,
	"./decidim/vendor/social-share-button/tumblr.svg": 65184,
	"./decidim/vendor/social-share-button/twitter.svg": 12931,
	"./decidim/vendor/social-share-button/vkontakte.svg": 88425,
	"./decidim/vendor/social-share-button/wechat.svg": 48316,
	"./decidim/vendor/social-share-button/whatsapp.svg": 7028,
	"./decidim/vendor/social-share-button/x.svg": 10534,
	"./decidim/vendor/social-share-button/xing.svg": 37490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98328;